"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTracking = exports.renderArrival = void 0;
const react_1 = __importDefault(require("react"));
//
// components
//
const ModalButton_1 = __importDefault(require("./Tables/ModalButton"));
//
// styles
//
const StyledArrivalStatus_1 = require("./Tables/StyledArrivalStatus");
const StyledLateArrivalStatus_1 = require("./Tables/StyledLateArrivalStatus");
const StyledText_1 = require("./Tables/StyledText");
function renderArrival(arrival) {
    if (arrival === 'LATE') {
        return (react_1.default.createElement(StyledLateArrivalStatus_1.StyledLateArrivalStatus, { className: 'arrival' }, "Late"));
    }
    if (arrival === 'EARLY') {
        return (react_1.default.createElement(StyledArrivalStatus_1.StyledArrivalStatus, { className: 'arrival', status: 'early' }, "Early"));
    }
    return react_1.default.createElement(StyledArrivalStatus_1.StyledArrivalStatus, { className: 'arrival' }, "On Time");
}
exports.renderArrival = renderArrival;
function renderTracking(row, bold = false) {
    return (react_1.default.createElement(StyledText_1.StyledText, { bold: bold, className: 'tracking-code' },
        row.trackingCode,
        react_1.default.createElement(ModalButton_1.default, { orderNumber: row.trackingCode })));
}
exports.renderTracking = renderTracking;
